export var SnackType;

(function (SnackType) {
  SnackType["Primary"] = "primary";
  SnackType["Success"] = "success";
  SnackType["Error"] = "error";
  SnackType["Info"] = "info";
  SnackType["Warning"] = "warning";
})(SnackType || (SnackType = {}));